export const documents = [
  ['丹佛斯 NeoCharge 低充注方案', 'Danfoss_IRF NeoCharge Solution.pdf', '应用方案', '在保证系统效率的同时显著减少大型制冷系统的制冷剂充注量，适用于氨、HFC及 CO₂ 系统。'],
  ['ICFD 除霜模块案例分析（CO₂）', 'ICFD defrost module from Danfoss test on.pdf', '应用方案', '展示 ICFD 除霜模块在简化系统、提升效率和节约能源方面的优势。'],
  ['ICFD 除霜模块：提升性能与降低能耗', 'Improve defrost.pdf', '应用方案', '高效排液方式可减少气体旁通量，从而降低压缩机负荷和能源消耗。'],
  ['工业制冷应用手册（氨与 CO₂）', 'industrial refrigeration ammonia and co2 application.pdf', '应用方案', '涵盖制冷剂特性、系统设计、压缩机与蒸发器控制及安全系统。'],
  ['ICV Flexline™：降低生命周期成本', 'reduce lifecycle cost.pdf', '应用方案', '模块化设计为氨、CO₂及未来高压制冷剂系统提供灵活解决方案。'],
  ['电动阀与执行器（ICM 和 ICAD）', '032-ICM+ICADB.pdf', '产品资料', 'ICM 系列电动阀和 ICAD 执行器的技术数据、功能与应用。'],
  ['丹佛斯工业制冷控制元件产品样本', '20230309 丹佛斯工业制冷控制元件.pdf', '产品资料', '工业制冷控制元件的综合产品资料。'],
  ['截止阀和调节阀', '截止阀和调节阀.pdf', '产品资料', 'SVA 截止阀与 REG 调节阀产品信息。'],
  ['工业制冷组件与控制方案', 'Industrial Refrigeration Components and Controls.pdf', '产品资料', '工业制冷领域关键组件与控制解决方案概览。'],
  ['智能排空系统（IPS）', 'IPS.pdf', '产品资料', '有效去除制冷系统中的不凝性气体，提升系统效率。'],
  ['工业制冷用过滤器', 'strainers for industrial refrigenration.pdf', '产品资料', '保护压缩机和阀件免受杂质损害。'],
  ['压力开关与温控器', 'switches and thermostats for industrial refrigeration.pdf', '产品资料', '为制冷系统提供精确的压力与温度控制。'],
  ['工业制冷压力和温度调节阀', '工业制冷压力和温度调节阀.pdf', '产品资料', '用于精确控制工业制冷系统压力和温度的调节阀。'],
  ['工业制冷液位调节阀', '工业制冷液位调节阀.pdf', '产品资料', '确保制冷系统液位控制安全稳定运行。'],
  ['工业制冷组合阀', '工业制冷组合阀.pdf', '产品资料', 'ICF 组合阀站将多项功能集成一体。'],
  ['过滤器', '过滤器.pdf', '产品资料', '过滤器产品技术资料。'],
  ['智能空分系统（IPS8）', '智能空分系统（IPS8）.pdf', '产品资料', '解决制冷系统中的空气分离问题，提升效率并降低能耗。'],
  ['工业制冷截止阀和调节阀', 'hut-off and regulating valves.pdf', '产品资料', '工业制冷截止与调节阀英文产品资料。'],
].map(([title, filename, category, description], index) => ({ id: index + 1, title, filename, category, description, updated: '2025-06-24' }))
